<template>
  <div class="app-container financeList">
    <panelGroup :detail="detail" v-if="detail"/>
    <div class="listHeader">
       时间段:
      <el-date-picker
        v-model="listQuery.start_date"
        type="date"
        placeholder="开始日期"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
      至
      <el-date-picker
        v-model="listQuery.end_date"
        type="date"
        placeholder="结束日期"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
      <el-input v-model="listQuery.shop_name" placeholder="请输入店铺名称" :clearable="true" style="width: 200px;margin-left:20px"></el-input>
      <el-button style="margin-left:10px;" size="small" type="primary" @click="search">搜索</el-button>
    </div>

    <el-table
      :loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="margin-top: 15px;">
      <el-table-column label="序号" align="center" width="95">
        <template slot-scope="scope">{{scope.$index+1 }}</template>
      </el-table-column>
      <el-table-column label="店铺名称" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.name}}</template>
      </el-table-column>
      <el-table-column label="总营业额" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.turnover_count}}</template>
      </el-table-column>
           <el-table-column label="已提现金额" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.withdrawn}}</template>
      </el-table-column>
      <el-table-column label="余额" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.shop_account?scope.row.shop_account.balance:""}}</template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="300">
        <template slot-scope="scope">
          <el-button size="small" @click="handleShowFinance(scope.row)">查看流水</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.limit"
        :page-sizes="[10,20,30,50]"
        :total="total"
        background
        layout="total,sizes,prev,pager,next,jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"></el-pagination>
    </div>
  </div>
</template>

<script>
import panelGroup from "@/components/panelGroup/schoolFinIndex.vue";
import request from "@/utils/request";
export default {
  components: {
    panelGroup,
  },
  data() {
    return {
      listLoading: false,
      total: 1,
      listQuery: {
        page: 1,
        limit: 10,
        shop_name:"",
        start_date:"",
        end_date:""
      },
      list: [],
      detail: {}
    }
  },
  created() {
    this.getList()
    this.getDataCount()
  },
  methods: {
    getList() {
       this.listQuery.start_date = this.listQuery.start_date
        ? (this.listQuery.start_date + " 00:00:00")
        : "";
      this.listQuery.end_date = this.listQuery.end_date
        ? (this.listQuery.end_date + " 23:59:59")
        : "";
      this.listLoading = true
      request({
        url: "/api/backend/shop/finance",
        method: "get",
        params: this.listQuery
      })
        .then(result => {
          this.list = result.data.data;
          this.total = result.data.total;
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getDataCount() {
      let start_datetime = this.listQuery.start_date
        ? (this.listQuery.start_date )
        : "";
      let end_datetime = this.listQuery.end_date
        ? (this.listQuery.end_date )
        : "";
      request({
        url: "/api/backend/finance/shop/dataCount",
        method: "get",
        params: {
          start_datetime,
          end_datetime
          // school_id: this.listQuery.school_id
        }
      })
        .then(result => {
          this.detail = result.data;
          this.listQuery.start_datetime=start_datetime;
          this.listQuery.end_datetime=end_datetime;
           this.detail.listQuery=this.listQuery;
        })
        .catch(err => {
          console.log(err);
        });
    },
    search() {
      this.listQuery.page = 1
      this.getList()
      this.getDataCount()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    handleShowFinance(row) {
      this.$router.push('/finance/flowingWater?id=' + row.id )
    },
  }
}
</script>

<style>

</style>
